import { Flex } from '@aloft/toolkit-sui';

import { PropsWithChildren } from 'react';

import { popoverInputFocusSx } from '../styles.ts';

type PopoverInputHeaderProps = PropsWithChildren<{
  inputFocused: boolean;
}>;

export const PopoverInputHeader = ({ inputFocused, children }: PopoverInputHeaderProps) => (
  <Flex
    alignItems="center"
    justifyContent="space-between"
    width="100%"
    height="32px"
    gap="4px"
    padding="4px 8px"
    borderWidth="0px"
    borderStyle="solid"
    borderColor="strokeDefault"
    borderBottomWidth="1px"
    __dangerDoNotUseSx={{
      ...(inputFocused && popoverInputFocusSx),
    }}
  >
    {children}
  </Flex>
);
